import { memo } from 'react';

import CustomPrompt from 'components/CustomPrompt/CustomPrompt';

const WithPrompt = ({ isTouched, setIsTouched, rootPath, onResetFields, children }: any) =>
  <>
    <CustomPrompt
      rootPath={rootPath}
      isNeedBlock={isTouched}
      setIsTouched={setIsTouched}
      onResetFields={onResetFields}
    />
    {children}
  </>;

export default memo(WithPrompt);
